<template>
  <div class="returnAdd">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('registerForCredit.collapseTitle.baseTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <base-form ref="baseForm" :type="$route.query.type" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- 修改 -->
      <el-button type="primary" @click="edit()" :loading="loading" class="fixed-bottom-btn">{{
        this.$t('applicationDetail.btnList.edit')
      }}</el-button>
      <el-button
        type="primary"
        @click="save('001')"
        :disabled="$route.query.returnStatus != 1"
        :loading="loading"
        class="fixed-bottom-btn"
        >{{ this.$t('registerForCredit.btnList.save') }}</el-button
      >
      <!-- 提交（确认登记） -->
      <el-button
        type="primary"
        @click="save('002')"
        :disabled="$route.query.returnStatus != 1"
        :loading="loading"
        class="fixed-bottom-btn"
        v-hasPermi="['2021042916311702647']"
        >{{ this.$t('registerForCredit.btnList.submit') }}</el-button
      >
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BaseForm from '../detailOrAcceptCredit/components/baseForm'; // 基本信息
  import API from '@/api/capitalCenter/letterOfCredit';
  // import { resolve, reject } from 'q';

  export default {
    name: 'registerForCreditLC',
    components: {
      BaseForm,
    },
    data() {
      return {
        loading: false,
        activeNames: ['1'],
        componentsList: ['baseForm'],
        allDetail: '',
        exchangeLadingNo: '', //附件列表
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
    },
    mounted() {},
    methods: {
      // 点击修改/显示
      edit() {
        this.$route.query.returnStatus = this.$route.query.returnStatus == '4' ? '1' : '4';
      },
      save(btnType) {
        let params = {};
        let momentObj = this.$refs['baseForm'].exportChildData(btnType);
        if (momentObj) {
          params = Object.assign(params, momentObj);
        } else {
          return;
        }
        this.saveData(btnType, params);
      },
      saveData(btnType, params) {
        params = Object.assign(params, {});
        params = this.$baseRequest.assignObj(params);
        params.gmtCreate = null;
        this.loading = true;
        // 保存提交
        this.$axios.post(API.OPERA_CREDITLETTER, params).then((res) => {
          this.loading = false;
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              message:
                btnType == '001'
                  ? this.$t('registerForCredit.msg.saveSussess')
                  : this.$t('registerForCredit.msg.submitSusscess'),
              type: 'success',
            });
            if (btnType == '001') {
              this.$refs.baseForm.baseData = res.data.data;
            } else {
              this.returnPath();
            }
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 返回列表页
      returnPath() {
        let path = {
          fromPath: {
            path: '/letterOfCredit/registerForCredit',
            name: 'registerForCreditLC',
            meta: {
              keepAlive: true,
              title: '信用证收证登记',
            },
          },
          toPath: {
            path: '/letterOfCredit/searchReceiveCredit',
            name: 'searchReceiveCreditLC',
            meta: {
              keepAlive: false,
              title: '信用证收证查询',
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>
